import React from 'react';
import styled, { keyframes } from 'styled-components';
import { semanticColors } from '@/common/styles/colorTokens';

interface LoadingModalProps {
  isOpen: boolean;
  message?: string;
}

const LoadingModal: React.FC<LoadingModalProps> = ({ 
  isOpen, 
  message = "파일 업로드 중입니다..."
}) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay>
      <ModalContent>
        <Spinner />
        <LoadingText>{message}</LoadingText>
      </ModalContent>
    </ModalOverlay>
  );
};

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: ${semanticColors.background.secondary};
  border-radius: 12px;
  padding: 1rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 360px;
  height: 140px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
`;

const Spinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid ${semanticColors.border.primary};
  border-top: 4px solid ${semanticColors.background.brand};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const LoadingText = styled.p`
  margin-top: 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  color: ${semanticColors.text.primary};
  text-align: center;
  font-weight: 500;
`;

export default LoadingModal; 